import 'platform';
import { gpCommon } from '../app';
import { log, LoggingCategory } from '../util/logger';

declare interface Platform {
    name: string;
    version: string;
    layout: string;
    os: {
        architecture: string;
        family: string;
        version: string;
        toString(): string;
    };
    description: string;
    product: string;
    manufacturer: string;
}

declare var platform: Platform;

export interface ILogglyService {
    information(msgTemplate: string, args: any[], extraProperties?: any): void;
    error(msgTemplate: string, args: any[], extraProperties?: any): void;

    withValues(extraProperties: { key: string; value: any }[]): ILogglyService;
    withCategory(category: LoggingCategory): void;
}

export type gpLogger = ILogglyService;
export type gpLoggerService = ILogglyService;

export type gpLogglyService = ILogglyService;

export function getScreenInformation() {
    return {
        "platform.name": platform.name,
        "platform.version": platform.version,
        "platform.layout": platform.layout,
        "platform.os": platform.os ? platform.os.toString() : "",
        "platform.description": platform.description,
        "platform.product": platform.product,
        "platform.manufacturer": platform.manufacturer,
        "window.innerWidth": window.innerWidth,
        "window.innerHeight": window.innerHeight,
        "window.outerWidth": window.outerWidth,
        "window.outerHeight": window.outerHeight,
        "window.screen.width": window.screen.width,
        "window.screen.height": window.screen.height,
        "window.screen.availWidth": window.screen.availWidth,
        "window.screen.availHeight": window.screen.availHeight,
    };
}

let logToConsole = false;
let logToServer = true;


if (typeof (__gameplan_is_local_development) !== 'undefined' && __gameplan_is_local_development) {
    logToConsole = true;
    logToServer = false;
}

declare module 'angular' {
  namespace auto {
    interface IInjectorService {
      get(name: typeof gpLogglyService_ServiceName): ILogglyService;
    }
  }
}


export const gpLogglyService_ServiceName = 'gpLogglyService' ;
gpCommon.factory(gpLogglyService_ServiceName, [function () { return new LogglyService() }]);

class LogglyService implements ILogglyService {

    private defaultExtraProperties: { key: string; value: any }[] = [];

    public constructor(public readonly category: LoggingCategory = 'general') {
    }

    public withValues(extraProperties: { key: string; value: any }[]): ILogglyService {
        const newService = new LogglyService(this.category);

        this.defaultExtraProperties.forEach(pair => newService.defaultExtraProperties.push(pair));

        if (extraProperties) {
            extraProperties.forEach(pair => newService.defaultExtraProperties.push(pair));
        }

        return newService;
    }


    public withCategory(category: LoggingCategory) {
        const newService = new LogglyService(category);

        newService.defaultExtraProperties = this.defaultExtraProperties;
    }

    public information(msgTemplate: string, args: any[], extraProperties?: any): void {
        if (__gpLog) {

            extraProperties = this.mergeDefaultProps(extraProperties);

            if (logToServer) {
                __gpLog(msgTemplate, args, extraProperties);
            }
        }

        if (logToConsole) {
            log(this.category, msgTemplate, args, extraProperties ? JSON.stringify(extraProperties, null, '\t') : "");
        }
    }
    public error(msgTemplate: string, args: any[], extraProperties?: any): void {
        //TODO: differentiate between errors
        if (__gpLog) {

            extraProperties = this.mergeDefaultProps(extraProperties);

            if (logToServer) {
                __gpLog(msgTemplate, args, extraProperties);
            }
        }

        if (logToConsole) {
            log(this.category, msgTemplate, args, extraProperties ? JSON.stringify(extraProperties, null, '\t') : "");
        }
    }

    private mergeDefaultProps(extraProperties: { [key: string]: any }) {
        if (this.defaultExtraProperties && this.defaultExtraProperties.length > 0) {
            var oldProps = extraProperties;
            extraProperties = {};

            this.defaultExtraProperties.forEach(pair => extraProperties[pair.key] = pair.value);

            if (oldProps) {
                for (var key in oldProps) {
                    extraProperties[key] = oldProps[key];
                }
            }
        }

        return extraProperties;
    }
}
